
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        }
    }
})
